import { z } from 'zod';

export const KpiSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1),
    description: z.string().optional(),
    targetValue: z.number().optional(),
    currentValue: z.number().optional(),
    unit: z.string().optional(),
    frequency: z.string().optional(),
    calculationMethod: z.string().optional(),
    responsible: z.string().optional(),
    status: z.string().default('active'),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});
export const CreateKpiSchema = KpiSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateKpiSchema = KpiSchema.partial();
export const KPIFormSchema = KpiSchema;
